export const ORGANIZATION_CLIENTS_UPDATE_LIST = '@users/ORGANIZATION_CLIENTS_UPDATE_LIST'
export const ORGANIZATION_CLIENTS_SET_FETCHING = '@users/ORGANIZATION_CLIENTS_SET_FETCHING'
export const ORGANIZATION_USERS_UPDATE_LIST = '@users/ORGANIZATION_USERS_UPDATE_LIST'
export const ORGANIZATION_USERS_SET_FETCHING = '@users/ORGANIZATION_USERS_SET_FETCHING'
export const THEME_PARTICIPANTS_UPDATE_LIST = '@users/THEME_PARTICIPANTS_UPDATE_LIST'
export const THEME_PARTICIPANTS_SET_FETCHING = '@users/THEME_PARTICIPANTS_SET_FETCHING'
export const THEME_ADMINS_UPDATE_LIST = '@users/THEME_ADMINS_UPDATE_LIST'
export const THEME_ADMINS_SET_FETCHING = '@users/THEME_ADMINS_SET_FETCHING'
